const cameronGameDialogDataset = {
  friendName: "Cameron",
  dialogTable: [

    // 1
    {title: "Introduce Cameron",
      text: "Hey! I heard you just moved here. I'm Cameron—I think we met at that wild party " +
        "a while ago. Since I live close by, I thought I'd come by and say hi!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Good to meet you. Want to come in for a bit?", moodPoints: 2, rltnPoints: +2},
        {rspText: "Hello... I'm busy right now. See you around.", moodPoints: -1, rltnPoints: -2}
      ]
    },

    // 2
    {title: "Live at Parent's House",
      text: "Yeah, I still live with my parents. Got my own basement entrance too, so I can come " +
        "and go without them noticing. Pretty sweet, huh?",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "That sounds nice.", moodPoints: 1, rltnPoints: +1},
        {rspText: "Really? You still live at home?", moodPoints: -1, rltnPoints: -1}
      ]
    },

    // 3
    {title: "Out to Dinner, My Treat",
      text: "Hey, want to go out for dinner? My parents just gave me some money, so it's my treat. " +
        "Don’t worry, I’ve got this!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "No, I don't want to go out tonight.", moodPoints: -1, rltnPoints: -2},
        {rspText: "Absolutely, that sounds great.", moodPoints: 1, rltnPoints: +1}
      ]
    },

    // 4
    {title: "Roommate Bummer",
      text: "You have a roommate? Ugh, I could never do that. I like my freedom too much!",
      conditionList: ["roommate"], type: "inPerson",
      responses: [
        {rspText: "Actually, I like having a roommate. Someone to talk to, you know?", moodPoints: -2, rltnPoints: -1},
        {rspText: "Yeah, sometimes it's a pain.", moodPoints: 1, rltnPoints: +1}
      ]
    },

    // 5
    {title: "Job Options",
      text: "No job right now. I might start looking, but honestly… no rush. Life’s too short!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Hmmmm... I wish I didn't have to work!!", moodPoints: 1, rltnPoints: +1},
        {rspText: "Must be nice.", moodPoints: -2, rltnPoints: -1}
      ]
    },

    // 6
    {title: "Out for Fun with Cameron",
      text: "Wanna go out tonight? I know it’s late, but let’s have some fun!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "No, I have work tomorrow.", moodPoints: -1, rltnPoints: -1},
        {rspText: "Sure, let's go!", moodPoints: 1, rltnPoints: +2, costAmt: -83.27}
      ]
    },

    // 7
    {title: "College Degrees",
      text: "I double-majored in psychology and sociology. Great degrees… if you want to work for peanuts.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Hmmm... some degrees just aren't in demand.", moodPoints: 1, rltnPoints: +1},
        {rspText: "There must be a job you could find.", moodPoints: -2, rltnPoints: -2}
      ]
    },

    // 8
    {title: "Trip to France",
      text: "Ever been to France? I went a few times with my parents. Paris is amazing, and the food… " +
        "unforgettable!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "That sounds really cool!", moodPoints: 1, rltnPoints: +1},
        {rspText: "Not really my thing.", moodPoints: -2, rltnPoints: -2}
      ]
    },

    // 9
    {title: "Living in Apartment",
      text: "You’re still in an apartment? Pfft, you should think about upgrading to a house!",
      conditionList: ["homeType-apartment"], type: "inPerson",
      responses: [
        {rspText: "I've been thinking the same thing!", moodPoints: 1, rltnPoints: +1},
        {rspText: "No way! I like it here.", moodPoints: -1, rltnPoints: -1}
      ]
    },

    // 10
    {title: "Hockey Game and Dinner",
      text: "Got tickets to a hockey game. Want to come? I’ll even pay for a quick dinner beforehand.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Count me in!", moodPoints: 1, rltnPoints: +1},
        {rspText: "Nah, too busy.", moodPoints: -2, rltnPoints: -2}
      ]
    },

    // 11
    {title: "New Car",
      text: "I just got a new car. Want to come see it? Bet your ride isn’t as nice.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "No, I'm busy.", moodPoints: -1, rltnPoints: -2},
        {rspText: "Sure, what kind of car?", moodPoints: 1, rltnPoints: +1}
      ]
    },

    // 12
    {title: "Parents Tell Him to Move Out",
      text: "Bummed… my step-dad said I have to move out soon. Guess I need a job too.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Whoa! Tough news.", moodPoints: -1, rltnPoints: 1},
        {rspText: "Time to adult, huh?", moodPoints: 2, rltnPoints: +1}
      ]
    },

    // 13
    {title: "Job Hunting",
      text: "Looking for a job is tough. Most pay barely enough. At least I’ve got my degrees… " +
        "kinda useless though.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Yup, hard market.", moodPoints: -1, rltnPoints: -2},
        {rspText: "You’ll find something.", moodPoints: 1, rltnPoints: +1}
      ]
    },

    // 14
    {title: "Found a Job",
      text: "Got a new job selling insurance. Low pay to start, but maybe I’ll get lucky.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Good luck with that!", moodPoints: -1, rltnPoints: +1},
        {rspText: "Selling insurance is tough!", moodPoints: 1, rltnPoints: +1}
      ]
    },

    // 15
    {title: "Friend List",
      text: "Mind sharing your friends’ numbers for work contacts? Promise I won’t spam them.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "No, thanks.", moodPoints: 1, rltnPoints: -2},
        {rspText: "Sure, here you go.", moodPoints: -2, rltnPoints: +2}
      ]
    },

    // 16
    {title: "Want to Go Out?",
      text: "Got my allowance! Want to go grab dinner? My treat.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "You should save that.", moodPoints: 1, rltnPoints: -2},
        {rspText: "Sounds fun!", moodPoints: -1, rltnPoints: +2}
      ]
    },

    // 17
    {title: "Job is Difficult",
      text: "My job is hard. I call people all day and get mostly 'No'. Some are rude too.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Not surprised!", moodPoints: -1, rltnPoints: -2},
        {rspText: "Sorry to hear that.", moodPoints: -1, rltnPoints: +1}
      ]
    },

    // 18
    {title: "Thinking of Quitting",
      text: "I hate my job. Might quit soon. Parents say I still need to move out though.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Good idea.", moodPoints: -1, rltnPoints: -2},
        {rspText: "Quitting already?", moodPoints: -1, rltnPoints: +1}
      ]
    },

    // 19
    {title: "Tennis Anyone?",
      text: "Parents' tennis club lets me bring a friend. Wanna come play? I’m not great, but it’s fun!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Sure, I'll come!", moodPoints: 2, rltnPoints: +2},
        {rspText: "Nah, I don’t like tennis.", moodPoints: -1, rltnPoints: -2}
      ]
    },

    // 20
    {title: "Quit my Job",
      text: "I quit! Parents said they'd cover first month’s rent and deposit. Time to find an apartment.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Did you search online?", moodPoints: -1, rltnPoints: +1},
        {rspText: "No ideas to help?", moodPoints: -1, rltnPoints: -1}
      ]
    },

    // 21
    {title: "Found an Apartment",
      text: "Found a small apartment! Game room and pool included. Come check it out after I move in!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Sounds great!", moodPoints: -1, rltnPoints: +1},
        {rspText: "Nice to have rich parents, eh?", moodPoints: -2, rltnPoints: -1}
      ]
    },

    // 22
    {title: "Moving Into Apartment",
      text: "Moving next week! Can you help me? Dinner’s on me after.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Sorry, busy.", moodPoints: -1, rltnPoints: -2},
        {rspText: "Sure!", moodPoints: -2, rltnPoints: +4}
      ]
    },

    // 23
    {title: "Finding a New Job",
      text: "Thinking about real estate. Need license first—4 weeks of classes, then an exam.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Real estate is hard work.", moodPoints: -1, rltnPoints: -2},
        {rspText: "Could be fun!", moodPoints: +1, rltnPoints: +1}
      ]
    },

    // 24
    {title: "Party in New Apartment",
      text: "Throwing a party to celebrate! Game room is $150/hr. Should I ask guests to chip in $20?",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "As long as they know.", moodPoints: -1, rltnPoints: +1},
        {rspText: "No way!", moodPoints: -2, rltnPoints: -1}
      ]
    },

    // 25
    {title: "Party Planned",
      text: "Decided not to reserve the game room. Still fun—pool or ping pong if it’s free. You coming?",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Maybe if I can.", moodPoints: -1, rltnPoints: -2},
        {rspText: "Absolutely!", moodPoints: 1, rltnPoints: +2}
      ]
    },

    // 26
    {title: "Financial Woes",
      text: "Rent’s high. I might need another bailout from mom. Life’s expensive!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "You need to budget better.", moodPoints: -2, rltnPoints: -1},
        {rspText: "Want me to help?", cashAmt: -500, itemDesc: "Help Cameron", moodPoints: -1, rltnPoints: +3}
      ]
    },

    // 27
    {title: "Shopping Spree",
      text: "Saw a leather couch I love. Way over budget, but maybe I should just get it anyway?",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Don’t spend it!", moodPoints: -2, rltnPoints: -1},
        {rspText: "Go for it!", cashAmt: -1200, itemDesc: "Luxury Couch", moodPoints: -1, rltnPoints: +2}
      ]
    },

    // 28
    {title: "Fancy Night Out",
      text: "Rooftop bar tonight! Drinks are pricey but the view is epic. Join me?",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Sounds expensive.", moodPoints: 1, rltnPoints: 1},
        {rspText: "Absolutely!", cashAmt: -95, itemDesc: "Rooftop Night", moodPoints: 2, rltnPoints: 3}
      ]
    },

    // 29
    {title: "Parents Bailing Out",
      text: "Mom helped cover rent again. Step-dad’s not thrilled… typical.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Dangerous pattern.", moodPoints: -2, rltnPoints: -2},
        {rspText: "Good for you!", moodPoints: 2, rltnPoints: 2}
      ]
    },

    // 30
    {title: "Budget Lesson",
      text: "I made a budget! Or at least tried… mostly just a notebook with numbers.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Better than nothing.", moodPoints: 1, rltnPoints: +1},
        {rspText: "I’d love to see it!", moodPoints: 2, rltnPoints: 2}
      ]
    },

    // 31
    {title: "Weekend Adventure",
      text: "Planning a weekend adventure—brunch, shopping, maybe a day trip. You in?",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Too expensive for me.", moodPoints: -1, rltnPoints: -1},
        {rspText: "Absolutely!", cashAmt: -250, itemDesc: "Weekend with Cameron", moodPoints: 2, rltnPoints: 3}
      ]
    },

    // 32
    {title: "Too Lazy to Work",
      text: "I switched jobs again… can’t seem to stick with anything. At least I’m trying, sorta.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "You need consistency.", moodPoints: -2, rltnPoints: -1},
        {rspText: "Better than nothing, I guess.", moodPoints: 1, rltnPoints: 1}
      ]
    },

    // 33
    {title: "Expensive Habits",
      text: "I keep buying fancy stuff even when I can’t afford it. Mom always bails me out… it’s like a safety net.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "You’ll never learn like this.", moodPoints: -2, rltnPoints: -1},
        {rspText: "At least you’re happy!", moodPoints: 1, rltnPoints: 1}
      ]
    },

    // 34
    {title: "Try Real Estate Again",
      text: "Thinking about trying real estate one more time. Maybe this will stick… maybe not.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Good luck!", moodPoints: 1, rltnPoints: +1},
        {rspText: "Seems risky.", moodPoints: -1, rltnPoints: -1}
      ]
    },

    // 35
    {title: "Party Recovery",
      text: "Last night’s party drained me… too much fun! But it was worth it.",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "You party too hard!", moodPoints: -1, rltnPoints: -1},
        {rspText: "Sounds fun!", moodPoints: 2, rltnPoints: +2}
      ]
    },

    // 36
    {title: "Game Night",
      text: "Hosting a game night at my place! Pool, ping pong, maybe even video games. You coming?",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "I’ll pass.", moodPoints: -1, rltnPoints: -1},
        {rspText: "Absolutely!", moodPoints: 1, rltnPoints: +2}
      ]
    },

    // 37
    {title: "Sports Bar Fun",
      text: "Going to the sports bar tonight. Drinks on me if you join. Live a little!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Too expensive.", moodPoints: 1, rltnPoints: -1},
        {rspText: "I’m in!", cashAmt: -60, itemDesc: "Sports Bar Drinks", moodPoints: 1, rltnPoints: 2}
      ]
    },

    // 38
    {title: "Road Trip",
      text: "Thinking of a road trip. Nothing fancy, just fun. You want to come?",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Not this time.", moodPoints: -1, rltnPoints: -1},
        {rspText: "Yes, let’s go!", cashAmt: -180, itemDesc: "Road Trip", moodPoints: 2, rltnPoints: 3}
      ]
    },

    // 39
    {title: "Late Night Snack",
      text: "I’m craving late-night pizza. Want to join me? My treat!",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "No, I’m full.", moodPoints: -1, rltnPoints: -1},
        {rspText: "Absolutely!", cashAmt: -25, itemDesc: "Pizza Treat", moodPoints: 1, rltnPoints: 2}
      ]
    },

    // 40
    {title: "Trying Something New",
      text: "Thinking about trying a cooking class. It’s expensive but could be fun! What do you think?",
      conditionList: [], type: "inPerson",
      responses: [
        {rspText: "Too pricey.", moodPoints: 1, rltnPoints: -1},
        {rspText: "Sounds fun!", cashAmt: -120, itemDesc: "Cooking Class", moodPoints: 2, rltnPoints: 2}
      ]
    }

  ]
};

export default cameronGameDialogDataset;
